import React from 'react';
import { Button, useNotify, useRecordContext, useRefresh, useResourceContext, useUpdate } from 'react-admin';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

/**
 * Ligar/desligar é o único jeito de parar (ou retomar) um brinde de conceder recompensa —
 * não existe edição de brinde. Desativar NÃO reverte o que os clientes já ganharam; o
 * brinde apenas para de conceder daqui pra frente.
 *
 * Reativar um brinde de "Número da Sorte" pode ser recusado pelo backend quando o sorteio
 * vinculado já encerrou — a mensagem do backend é mostrada como está.
 */
const ToggleGiftButton: React.FC = () => {
  const record = useRecordContext();
  const resource = useResourceContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const [update, { isLoading }] = useUpdate();

  // Brinde de campanha de recuperação é dirigido pela campanha (a janela do nível liga e
  // desliga; o clone nasceria sem campanha e sem público). O backend recusa; aqui nem oferece.
  if (!record || record.recoveryLevelId) { return null; }

  const isEnabled = !!record.isEnabled;

  const handleOnClick = (event: any) => {
    event.stopPropagation();

    const confirmed = window.confirm(
      isEnabled
        ? `Desativar o brinde "${record.name}"? Ele para de conceder recompensas imediatamente. O que os clientes já ganharam não é revertido.`
        : `Ativar o brinde "${record.name}"? Ele volta a conceder recompensas para quem cumprir as regras.`
    );
    if (!confirmed) { return; }

    update(
      resource,
      { id: record.id, data: { isEnabled: !isEnabled }, previousData: record },
      {
        onSuccess: () => {
          notify(isEnabled ? 'Brinde desativado' : 'Brinde ativado');
          refresh();
        },
        onError: (error: any) => {
          // O backend recusa a reativação com motivo (ex.: sorteio encerrado) — mostrar o motivo.
          const message = error?.body?.message || error?.message;
          notify(
            message || (isEnabled ? 'Não foi possível desativar, tente novamente' : 'Não foi possível ativar, tente novamente'),
            { type: 'warning' },
          );
        },
      },
    );
  };

  return (
    <Button
      onClick={handleOnClick}
      variant="outlined"
      color={isEnabled ? 'error' : 'success'}
      label={isEnabled ? 'Desativar' : 'Ativar'}
      startIcon={isEnabled ? <BlockIcon /> : <CheckCircleOutlineIcon />}
      disabled={isLoading}
    />
  );
};

export default ToggleGiftButton;
